// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoomContact } from './RoomContact';
import {
    RoomContactFromJSON,
    RoomContactFromJSONTyped,
    RoomContactToJSON,
    RoomContactToJSONTyped,
} from './RoomContact';

/**
 * 
 * @export
 * @interface RoomCreateInput
 */
export interface RoomCreateInput {
    /**
     * Hierarchical room ID (e.g. DE/Munich/Lab1)
     */
    roomId: string;
    /**
     * Room display name
     */
    name: string;
    /**
     * Room number
     */
    number?: string;
    /**
     * 
     */
    contact?: RoomContact;
}

/**
 * Check if a given object implements the RoomCreateInput interface.
 */
export function instanceOfRoomCreateInput(value: object): value is RoomCreateInput {
    if (!('roomId' in value) || value['roomId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function RoomCreateInputFromJSON(json: any): RoomCreateInput {
    return RoomCreateInputFromJSONTyped(json, false);
}

export function RoomCreateInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomCreateInput {
    if (json == null) {
        return json;
    }
    return {
        
        'roomId': json['roomId'],
        'name': json['name'],
        'number': json['number'] == null ? undefined : json['number'],
        'contact': json['contact'] == null ? undefined : RoomContactFromJSON(json['contact']),
    };
}

export function RoomCreateInputToJSON(json: any): RoomCreateInput {
    return RoomCreateInputToJSONTyped(json, false);
}

export function RoomCreateInputToJSONTyped(value?: RoomCreateInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roomId': value['roomId'],
        'name': value['name'],
        'number': value['number'],
        'contact': RoomContactToJSON(value['contact']),
    };
}

